import { render } from "./StickyMenu.vue?vue&type=template&id=62f0c034"
import script from "./StickyMenu.vue?vue&type=script&lang=js"
export * from "./StickyMenu.vue?vue&type=script&lang=js"

import "./StickyMenu.vue?vue&type=style&index=0&id=62f0c034&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__